import React, { useContext, useEffect, useRef } from 'react';
import { Alert, styled } from '@nextiva/next-ui-components';

import { RootContext, actionTypes } from 'RootContext/rootContext';
import {
  AttachmentsError,
  AttachmentsInProgress,
  AttachmentsSuccess,
} from './AttachmentsFileUpload.tsx';
import {
  ATTACHMENTS_ERROR,
  ATTACHMENTS_IN_PROGRESS,
  ATTACHMENTS_SUCCESS,
} from './const.ts';

const StyledAlert = styled(Alert, {
  shouldForwardProp: (prop) => prop !== 'isDrawer',
})`
  margin: ${({ isDrawer }) => (isDrawer ? '8px 0' : '8px 8px 8px 152px')};
  position: ${({ isDrawer }) => (isDrawer ? 'sticky' : 'absolute')};
  top: ${({ isDrawer }) => isDrawer && 0};
  z-index: 9999;
  .MuiAlert-message {
    flex-grow: 1;
  }
`;

const Snackbar = ({ isDrawer = false }) => {
  const {
    actions,
    rootDispatch,
    rootState: { globalSnackbar, drawerSnackbar },
  } = useContext(RootContext);

  const { autoHideDuration, isOpen, message, severity } = isDrawer
    ? drawerSnackbar
    : globalSnackbar;

  const idRef = useRef(null);

  const onClose = () => {
    rootDispatch({
      type: isDrawer
        ? actionTypes.CLOSE_DRAWER_SNACKBAR
        : actionTypes.CLOSE_GLOBAL_SNACKBAR,
    });
  };

  useEffect(() => {
    if (isOpen) {
      if (idRef.current) {
        clearTimeout(idRef.current);
      }

      idRef.current = setTimeout(() => {
        onClose();
      }, autoHideDuration);
    }
  }, [isOpen, autoHideDuration]);

  if (!isOpen) return null;

  if (actions.type === ATTACHMENTS_IN_PROGRESS)
    return (
      <AttachmentsInProgress
        onClose={onClose}
        severity={severity}
        message={message}
        onAction={actions.onAction}
      />
    );

  if (actions.type === ATTACHMENTS_SUCCESS)
    return (
      <AttachmentsSuccess
        onClose={onClose}
        severity={severity}
        message={message}
        onAction={actions.onAction}
      />
    );

  if (actions.type === ATTACHMENTS_ERROR)
    return (
      <AttachmentsError
        onClose={onClose}
        severity={severity}
        message={message}
        onAction={actions.onAction}
      />
    );

  return (
    <StyledAlert
      fullWidth={isDrawer}
      isDrawer={isDrawer}
      onClose={onClose}
      severity={severity}
    >
      {message}
    </StyledAlert>
  );
};

export default Snackbar;
